"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _StyledTextArea = _interopRequireDefault(require("./StyledTextArea"));

var _core = require("@emotion/core");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// This is the textarea padding, we need to take into consideration for calculation of height.
// Ideally we should get this magic number by using computeStyle, however that involves
// much more scenarios to consider such as, border width, margin, box-sizing etc, I would suggest in the future
// use third party library to calculate, eg. autosize npm
var PADDING = 32; // omitting ref, since voltron doesn't support React.RefObject<T> yet

var TextArea = function TextArea(_ref) {
  var ref = _ref.ref,
      resizable = _ref.resizable,
      autoResize = _ref.autoResize,
      uia = _ref.uia,
      innerRef = _ref.innerRef,
      restProps = (0, _objectWithoutProperties2.default)(_ref, ["ref", "resizable", "autoResize", "uia", "innerRef"]);
  var textAreaRef = (0, _react.useRef)();
  var doResize = (0, _react.useCallback)(function () {
    if (textAreaRef && textAreaRef.current) {
      textAreaRef.current.style.height = 'auto';
      textAreaRef.current.style.height = textAreaRef.current.scrollHeight - PADDING + 'px';
    }
  }, []);
  (0, _react.useEffect)(function () {
    if (textAreaRef.current && autoResize) {
      doResize();
    }
  }, [restProps.minHeight, restProps.maxHeight, restProps.height, restProps.value, autoResize, doResize]);

  var setRef = function setRef(el) {
    textAreaRef.current = el;

    if (typeof innerRef === 'function') {
      innerRef(el);
    }
  };

  var onChange = function onChange(e) {
    if (autoResize) {
      doResize();
    }

    if (restProps.onChange) {
      restProps.onChange(e);
    }
  };

  var styles = _objectSpread({}, restProps.style, {
    minHeight: restProps.height || restProps.minHeight,
    maxHeight: restProps.height || restProps.maxHeight,
    overflow: 'auto' // Fix for IE11

  });

  return (0, _core.jsx)(_StyledTextArea.default, (0, _extends2.default)({}, restProps, {
    resizable: resizable,
    ref: setRef,
    onChange: onChange,
    style: styles,
    "data-uia-textarea": uia
  }));
};

var _default = TextArea;
exports.default = _default;